import { ApiModule } from '@core';

export class TranslationsApi extends ApiModule {
  public loadTranslations(lang: string) {
    return this.api.get(`/tech/translations/${lang}`);
  }
}
